import { createContext, useContext, useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || "https://effortless-metaphor-api.ogtommype.workers.dev";
const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/site`)
      .then((r) => {
        if (!r.ok) throw new Error(`API returned ${r.status}`);
        return r.json();
      })
      .then(setData)
      .catch(setError);
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <div className="font-display font-black text-4xl text-red-500/50">ERR</div>
          <p className="label-mono text-neutral-500 mt-4">// failed to load transmission</p>
          <p className="text-neutral-600 text-xs mt-2 font-mono">{error.message}</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <div className="w-2 h-2 bg-neon animate-pulse mx-auto mb-4" />
          <p className="label-mono text-neutral-500">// loading transmission...</p>
        </div>
      </div>
    );
  }

  return <SiteContext.Provider value={data}>{children}</SiteContext.Provider>;
}

export function useSiteContent() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSiteContent must be used within SiteProvider");
  return ctx;
}
